import { connect } from 'react-redux';
import React from 'react';
import { bindActionCreators } from 'redux';
import { renderKBUserInput } from 'components/formAdapters/reduxFormAdapters';
import { Field,
reduxForm,
formValueSelector } from 'redux-form';
import * as valid from 'utils/validate';
import { KBForm,
KBTransfer,
KBButton } from
'components';
import { api } from 'app/services';
import { apiCallFailure } from 'app/actions';
import _ from 'lodash';

var OrgRentInfoForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.getLocFloors = this.getLocFloors.bind(this);this.getGroupedFloor = this.getGroupedFloor.bind(this);this.getAllAreasOfCurrentLoc = this.getAllAreasOfCurrentLoc.bind(this);this.getGroupedAreasByFloor = this.getGroupedAreasByFloor.bind(this);this.saveOrgInfoOfComplete = this.saveOrgInfoOfComplete.bind(this);this.saveOrgInfoOfLast = this.saveOrgInfoOfLast.bind(this);this.getAreas = this.getAreas.bind(this);this.selectedAreaOnChange = this.selectedAreaOnChange.bind(this);this.renderHiddenField = this.renderHiddenField.bind(this);}getInitialState()
  {
    const { floorsObj, areaSource, areaTarget } = this.props;
    return {
      formSubmitting: this.props.formSubmitting,
      areaSource,
      areaTarget,
      floorsObj: Array.isArray(floorsObj) ? floorsObj : [],
      currentSelectedFloors: [] };

  }componentDidMount()

  {
    const { areaSource } = this.state;
    if (areaSource.length < 1) {
      this.getLocFloors();
    }
  }getLocFloors()

  {
    const { location_id } = this.props;

    api.getLocationFloors(location_id).then(
    json => {
      const { org, setFloorAndAreas } = this.props;
      const floorsObj = json.response.body || [];
      const currentFloorSource = this.getGroupedFloor(floorsObj);

      const currentOrgAreas = org && org.areas || [];
      const areaTarget = this.getGroupedAreasByFloor(currentOrgAreas, floorsObj);

      this.setState({
        floorsObj,
        areaSource: currentFloorSource,
        areaTarget },
      () => {
        if (org.floor_info_id) {
          this.props.change('floor_info_id', org.floor_info_id);
        }
      });
      setFloorAndAreas && setFloorAndAreas(floorsObj, currentFloorSource, areaTarget);
      this.selectedAreaOnChange(areaTarget);
    },
    error => {
      this.setState({
        floorsObj: [],
        areaSource: [],
        areaTarget: [] });
    });
  }getGroupedFloor()

  {
    const floorsObj = arguments.length > 0 && arguments[0] !== undefined ?
      arguments[0] :
      this.state.floorsObj;

    let groupedFloor = [];
    Array.isArray(floorsObj) &&
    floorsObj.map(data => {
      let id = data.id || groupedFloor.length;
      let name = data.layer_num;

      let childrens = [];
      groupedFloor.push({ id, name, childrens });
    });
    return groupedFloor;
  }getAllAreasOfCurrentLoc(

  floor_info_id) {
    const { location_id, setFloorAndAreas, org } = this.props;
    const { floorsObj } = this.state;

    api.
    getAreas({
      location_id,
      area_type: 'private_office',
      includes: 'organizations,areas',
      floor_info_id: floor_info_id || null,
      per_page: 1000 }).

    then(json => {
      const areas = json.response.body || [];
      const currentOrgAreas = org && org.areas || [];

      const areaSource = this.getGroupedAreasByFloor(areas);
      const areaTarget = this.getGroupedAreasByFloor(currentOrgAreas);

      this.setState({
        areaSource,
        areaTarget });

      setFloorAndAreas && setFloorAndAreas(floorsObj, areaSource, areaTarget);
      this.selectedAreaOnChange(areaTarget);
    });
  }getGroupedAreasByFloor(

  areas, floorsSource) {
    const floorsObj = floorsSource || this.state.floorsObj;
    const groupedAreasByFloor = _.groupBy(areas, 'floor_info_id');
    let arrayedGroupedAreas = Object.values(groupedAreasByFloor);
    let groupedAreas = [];

    arrayedGroupedAreas &&
    arrayedGroupedAreas.map(data => {
      let id = groupedAreas.length || 0;
      let nameIndex = data[0] && data[0].floor_info_id;
      const floor = _.find(floorsObj, ['id', nameIndex]);
      let name = floor && floor.layer_num || '楼层未定';
      let childrens = data;
      groupedAreas.push({ id, name, childrens });
    });

    return groupedAreas;
  }componentDidUpdate(prevProps) {
    if (this.props.formSubmitting !== prevProps.formSubmitting) {
      this.setState({
        formSubmitting: this.props.formSubmitting });

    }
  }createField(

  name) {
    const { change, formValues = {}, formFieldMeta = {}, formSyncErrors = {} } = this.props;
    const fieldMeta = formFieldMeta[name] || {};
    return {
      value: formValues[name],
      touched: !!fieldMeta.touched,
      error: formSyncErrors[name],
      onChange: value => {
        const nextValue = value && value.target ? value.target.value : value;
        change(name, nextValue);
      } };

  }saveOrgInfoOfComplete(

  model) {
    const { saveParams } = this.props;
    saveParams && saveParams(model, 3, true);
  }saveOrgInfoOfLast()












































  {
    const { saveParams, setFloorAndAreas } = this.props;
    const areaTarget = this.areaTransfer.getData().target;
    saveParams && saveParams(this.props.formValues, 2);
    setFloorAndAreas && setFloorAndAreas(null, null, areaTarget);
  }getAreas(

  id) {

    const { location_id } = this.props;

    let areas = api.getAreas({
      location_id,
      area_type: 'private_office',
      // includes: 'organizations,areas',
      includes: 'occupancy',
      floor_info_id: id || null,
      per_page: 1000 }).

    then(({ json }) => {
      let newArr = [];
      const { entities: { areas = {} } = {} } = json;
      Object.values(areas).map(item => {
        if (item.state !== 'assigned' && item.state !== 'disabled') {
          newArr.push(item);
        }
      });
      return newArr;
    });
    return areas;
  }selectedAreaOnChange(

  data) {
    const {
      org } =
    this.props;
    const floorsArray = Object.values(this.state.floorsObj);
    let floorsOrgIn = [];
    let areas = [];
    const selectedFloorIds = data.map(d => {
      areas = areas.concat(d.childrens);
      return d.childrens[0].floor_info_id;
    });
    floorsOrgIn = floorsArray.
    filter(f => selectedFloorIds.includes(f.id)).
    map(f => {
      f.name = f.layer_num;
      return f;
    });
    this.setState({
      currentSelectedFloors: floorsOrgIn });

    const floorInfoId = floorsOrgIn.length === 1 ?
      floorsOrgIn[0] && floorsOrgIn[0].id :
      org && org.floor_info_id ||
      floorsOrgIn[0] && floorsOrgIn[0].id ||
      null;
    this.props.change('floor_info_id', floorInfoId);
    this.props.change('area_ids', areas.map(a => a.id).join(','));
  }renderHiddenField(

  { input }) {
    return <input {...input} type="hidden" />;
  }render()

  {
    const { handleSubmit, isUpdate, isWizard } = this.props;
    const {
      formSubmitting,
      areaSource,
      areaTarget,
      currentSelectedFloors } =
    this.state;
    const floor_info_id = this.createField('floor_info_id');
    const area_ids = this.createField('area_ids');
    const selectedFloor = currentSelectedFloors.filter(
    cf => cf.id == floor_info_id.value);


    return (
      <KBForm>
        <Field name="area_ids" component={this.renderHiddenField} />
        <Field name="floor_info_id" component={this.renderHiddenField} />
        <header className="kb-form-header">
          <h2 className="header-title">租赁信息</h2>
        </header>
        <div className="kb-form-container">
          {/* <div className="kb-tip-warning">
            <div className="icon"><i className="iconfont icon-hint" /></div>
            <div className="msg">注意：修改公司租赁房间信息后需要手动更新员工门禁权限</div>
            </div> */}
          <div
          style={{
            paddingBottom: 22,
            color: '#7F8FA4',
            fontSize: 12,
            fontWeight: 'bold' }}>


            <span className="must-fillR">*</span>租赁房间信息
          </div>
          <div className="kb-row">
            <KBTransfer
            ref={ref => { this.areaTransfer = ref; }}
            isSearch={false}
            isHead={true}
            isMiddle={false}
            isChildrenLoad={true}
            getExpandChilds={this.getAreas}
            multi={true}
            sourceTitle="可租房间"
            targetTitle="选中房间"
            source={areaSource}
            target={areaTarget}
            targetDataOnChange={this.selectedAreaOnChange} />

            {area_ids.touched && area_ids.error ?
            <p className="lr-error">{area_ids.error}</p> :
            null}
          </div>
          <div className="kb-row kb-form-66">
            <Field name="floor_info_id" component={renderKBUserInput}
            title="默认楼层"
            isRequired={true}
            placeholder="选择公司默认楼层"
            className="kb-form-group kb-form-210 kb-form-alone"

            disabled={currentSelectedFloors.length === 1}
            users={currentSelectedFloors}
            selectedUsers={selectedFloor}
            multi={false} />

          </div>

          <div className="kb-row">
            {!isWizard ?
            <KBButton
            className="certain-btn"
            type="button"
            onClick={this.saveOrgInfoOfLast}
            style={{ marginRight: 30 }}>

                上一步
              </KBButton> :
            null}
            {!isUpdate ?
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={formSubmitting}
            onClick={handleSubmit(this.saveOrgInfoOfComplete)}>

                {/* 稍后填写资料 */}
                完成编辑
              </KBButton> :

            <KBButton
            className="certain-btn"
            type="submit"
            submitting={formSubmitting}
            onClick={handleSubmit(this.saveOrgInfoOfComplete)}>

                完成编辑
              </KBButton>}

          </div>
        </div>
      </KBForm>);

  }};


function mapStateToProps(state, props) {
  const { org, urlParams } = props;
  const isUpdate = urlParams && urlParams.type === 'update' && org;
  const isWizard = urlParams && urlParams.wizard === '1' && org;
  const org_id = urlParams && urlParams.org_id;
  let space_id = Object.keys(state.entities.spaces || {})[0];
  let posUrl = org && org.business_license_positive_url || '';
  let negUrl = org && org.business_license_negative_url || '';
  let defaultBusinessLicense = posUrl ? [posUrl] : null;
  let defaultOtherLicense = negUrl ? [negUrl] : null;
  const selector = formValueSelector('OrgRentInfoForm');
  const formValues = selector(state, 'area_ids', 'floor_info_id') || {};

  return {
    org,
    org_id,
    space_id,
    isUpdate,
    isWizard,
    defaultBusinessLicense,
    defaultOtherLicense,
    formValues,
    formFieldMeta: state.form &&
    state.form.OrgRentInfoForm &&
    state.form.OrgRentInfoForm.fields ||
    {},
    formSyncErrors: state.form &&
    state.form.OrgRentInfoForm &&
    state.form.OrgRentInfoForm.syncErrors ||
    {},
    initialValues: org ?
    {
      ...org } :

    {} };

}

function mapDispatchToProps(dispatch) {
  return {
    apiCallFailureActions: bindActionCreators(apiCallFailure, dispatch) };

}

const validate = values => {
  const errors = {};

  if (valid.required(values.area_ids)) {
    errors.area_ids = '请至少选择一个分区作为默认分区';
  }

  if (valid.required(values.floor_info_id)) {
    errors.floor_info_id = '请选择公司默认楼层';
  }

  return errors;
};

const formConfig = {
  form: 'OrgRentInfoForm',
  validate: validate,
  touchOnBlur: false,
  enableReinitialize: true };

OrgRentInfoForm = reduxForm(formConfig)(OrgRentInfoForm);

export default connect(mapStateToProps, mapDispatchToProps)(OrgRentInfoForm);
